import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { List } from 'lucide-react';
import { ContentBreadcrumbs } from '@/features/shell/BreadcrumbBar';
import { ChatShellProvider, useChatShell } from './ChatShellContext';
import { ChatSessionList } from './components/ChatSessionList';
import { ChatSidebar } from './components/ChatSidebar';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const REFERENCES_WIDTH = 300;

function AskLayoutInner() {
  const [sessionsMobileOpen, setSessionsMobileOpen] = useState(false);
  const { showSources, citations } = useChatShell();

  return (
    <div
      className={cn(
        'app-frame app-frame--shell-layout app-frame--with-chat-sessions h-full flex flex-col min-h-0',
        showSources && 'app-frame--with-references',
      )}
    >
      <div className="lg:hidden flex-shrink-0 px-3 py-2 border-b border-border/60 bg-[var(--surface-main)]">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => setSessionsMobileOpen(true)}
          className="gap-2"
          aria-label="Open conversations"
        >
          <List className="h-4 w-4" />
          Conversations
        </Button>
      </div>

      <div className="app-frame-inner flex flex-1 min-h-0">
        <ChatSessionList
          mobileOpen={sessionsMobileOpen}
          onMobileClose={() => setSessionsMobileOpen(false)}
        />
        <main className="app-content-box flex flex-col min-h-0 min-w-0">
          <ContentBreadcrumbs />
          <div className="flex-1 min-h-0 min-w-0 flex flex-col overflow-hidden">
            <Outlet />
          </div>
        </main>
        {showSources && (
          <div className="references-box">
            <ChatSidebar width={REFERENCES_WIDTH} citations={citations} />
          </div>
        )}
      </div>
    </div>
  );
}

export function AskLayout() {
  return (
    <ChatShellProvider>
      <AskLayoutInner />
    </ChatShellProvider>
  );
}
